// useCan() — FE mirror of Authz::Capability.can? (server). Both layers
// answer the same string-keyed question off config/capabilities.yml.
// Server ships the role + capability list via Portal::ApplicationController#inertia_share.
//
// Usage:
//   const can = useCan()
//   if (can("team_invite")) <Button>Invite</Button>
//
// Per-row gates (e.g. "can THIS user remove THAT specific member") come from
// boolean flags on the serialized row payload, not from useCan — the server
// computes them via CompanyUser per-target predicates.

import { usePage } from "@inertiajs/react"

type CapabilityProps = {
  capabilities?: string[]
  currentRole?: string | null
}

export function useCan(): (cap: string) => boolean {
  const { props } = usePage<CapabilityProps>()
  // Inertia partial reloads / non-Portal pages can leave `capabilities`
  // as something other than an array. The `?? []` only catches nullish
  // values, so an empty object would still crash `caps.includes(...)`
  // and take down the sidebar. Guard with Array.isArray.
  const caps = Array.isArray(props.capabilities) ? props.capabilities : []
  return (cap: string) => caps.includes(cap)
}

export function useCurrentRole(): string | null {
  const { props } = usePage<CapabilityProps>()
  return props.currentRole ?? null
}
